<script>
import layout from '@src/mixins/layout.vue'
import AlertDialog from '@components/alert-dialog.vue'
import { caringCircleService } from '@/src/services/safehaven/AddCaringCircleService'

export default {
  components: {
    AlertDialog,
  },
  mixins: [layout],
  data() {
    return {
      isShowAlert: false,
      alertTitle: 'Remove person',
      alertMesasge:
        'You are are about to remove this person from your Caring Circle. This action cannot be undone.',
      personsData: [],
      deleteIndex: 0,
      snackbar: false,
      snackbarMessage: 'Error removing person. Please try again',
      imperialUnits: false,
      userWeight: null,
      userWeightLbs: null,
      userHeightFt: null,
      userHeightIn: null,
      userHeightMeters: null,
      panel: false,
    }
  },
  watch: {
    personsData(newVal) {
      this.panel = null
    },
  },
  mounted() {
    this.getCaringUsers()
  },
  created() {
    const userLogedData = JSON.parse(localStorage.getItem('auth.currentUser'))
    this.imperialUnits = userLogedData.user.imperial_units
  },
  methods: {
    updateImperialUniotData() {
      this.userData = JSON.parse(localStorage.getItem('auth.currentUser'))
      this.imperialUnits = this.userData.user.imperial_units
    },
    getName(person) {
      if (person.first_name !== '')
        return person.first_name + ' ' + person.last_name
      else return ''
    },
    async getCaringUsers() {
      caringCircleService.getCaringCircleUsers().then((res) => {
        this.caringUser = res.data.caringUser
        res.data.forEach((child) => {
          this.personsData.push(child)
        })
      })
    },
    editPersonInfo(person) {
      this.$router.push({
        name: 'caring-person-info',
        params: { myparam: person },
      })
    },
    showDeletePopup(deleteIndex) {
      this.isShowAlert = true
      this.deleteIndex = deleteIndex
    },
    handleSuccess() {
      this.isShowAlert = false
      const userId =
        this.personsData[this.deleteIndex].physician_data.dependent_id
      caringCircleService
        .deleteCaringCircleUsers(userId)
        .then((res) => {
          if (res.status === 200) this.personsData.splice(this.deleteIndex, 1)
        })
        .catch((error) => {
          console.warn(error)
          this.snackbar = true
        })
    },
    lbsTOkg(data) {
      if (data) return parseFloat(data * 2.20462).toFixed(1)
      else return '--'
    },
    meterConversion(data) {
      if (data) {
        return (
          parseInt(data / 0.3048) +
          'ft ' +
          Math.round((data % 0.3048) / 0.0254) +
          'in'
        )
      } else return '--'
    },
    showBlankEmergencyContact(dataObj) {
      if (
        dataObj.first_name === '' &&
        dataObj.last_name === '' &&
        dataObj.address === '' &&
        dataObj.city === '' &&
        dataObj.state === null &&
        dataObj.zipcode === '' &&
        dataObj.phone_number === ''
      ) {
        return '--'
      } else {
        return ''
      }
    },
    showBlankPhysician(dataObj) {
      if (
        dataObj.first_name === '' &&
        dataObj.last_name === '' &&
        dataObj.speciality === '' &&
        dataObj.hospital === '' &&
        dataObj.phone_number === ''
      ) {
        return '--'
      }
    },
  },
}
</script>

<template>
  <v-container :class="$style.pageContainer">
    <button
      id="updateImperialUnitButtonCaring"
      hidden
      @click="updateImperialUniotData"
    ></button>
    <AlertDialog
      :show-alert="isShowAlert"
      :alert-title="alertTitle"
      :alert-message="alertMesasge"
      @success="handleSuccess"
      @close-alert="isShowAlert = false"
    ></AlertDialog>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <div :class="$style.containwrap">
          <p :class="$style.pageDesc">
            CareClub+ includes people that you take care of or somebody that
            takes care of you. This could be your spouse, child, parent,
            caretaker or other family members.
          </p>
          <template>
            <div class="mb-4 mt-4">
              <v-expansion-panels v-model="panel">
                <v-expansion-panel
                  v-for="(person, index) in personsData"
                  :key="person.id"
                  class="mb-2"
                  :class="$style.expansionPanelContainer"
                >
                  <v-expansion-panel-header>
                    <v-row
                      no-gutters
                      style="display: flex; align-items: center"
                    >
                      <div class="mr-4">
                        <v-avatar small size="48" :class="$style.resize">
                          <v-img
                            v-if="person.dependent_data.profile_picture"
                            :src="person.dependent_data.profile_picture"
                            contain
                          />
                          <v-img
                            v-else
                            :src="
                              require('@assets/images/safehaven/Icon-Avatar.svg')
                            "
                            height="48"
                            width="48"
                            contain
                          ></v-img>
                        </v-avatar>
                      </div>
                      <v-col>
                        <p :class="$style.memberDetailsText">
                          {{ getName(person.dependent_data) || '--' }}
                        </p>
                      </v-col>
                    </v-row>
                    <template v-slot:actions>
                      <v-icon color="#0476D9"> mdi-menu-down </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="pl-4 pr-4">
                    <v-row
                      justify="space-around"
                      no-gutters
                      style="border-bottom: 1px solid #d1dfeb"
                      class="pb-4"
                    >
                      <v-col :cols="notDesktop ? 6 : 2">
                        <p :class="$style.memberDetailsHeader">RELATIONSHIP</p>
                        <p :class="$style.memberDetailsText">
                          My
                          {{
                            person.dependent_data.relationship
                              ? person.dependent_data.relationship.value
                              : '--'
                          }}
                        </p>
                      </v-col>

                      <v-col :cols="notDesktop ? 6 : 2">
                        <p :class="$style.memberDetailsHeader">DATE OF BIRTH</p>
                        <p :class="$style.memberDetailsText">
                          {{ person.dependent_data.dob || '--' }}
                        </p>
                      </v-col>

                      <v-col :cols="notDesktop ? 6 : 2">
                        <p :class="$style.memberDetailsHeader">SEX</p>
                        <p :class="$style.memberDetailsText">{{
                          person.dependent_data.sex
                            ? person.dependent_data.sex.value
                            : '--'
                        }}</p>
                      </v-col>

                      <v-col :cols="notDesktop ? 6 : 2">
                        <p :class="$style.memberDetailsHeader">
                          GENDER IDENTITY
                        </p>
                        <p :class="$style.memberDetailsText">{{
                          person.dependent_data.gender
                            ? person.dependent_data.gender.value
                            : '--'
                        }}</p>
                      </v-col>

                      <v-col :cols="notDesktop ? 6 : 4">
                        <p :class="$style.memberDetailsHeader">
                          RACE/ETHNICITY
                        </p>
                        <p :class="$style.memberDetailsText">{{
                          person.dependent_data.race
                            ? person.dependent_data.race.value
                            : '--'
                        }}</p>
                      </v-col>

                      <v-col :cols="notDesktop ? 6 : 2">
                        <p :class="$style.memberDetailsHeader"> WEIGHT </p>
                        <p :class="$style.memberDetailsText"
                          >{{
                            imperialUnits
                              ? lbsTOkg(person.dependent_data.weight)
                              : person.dependent_data.weight || '--'
                          }}
                          {{ imperialUnits ? 'Lbs' : 'Kg' }}</p
                        >
                      </v-col>

                      <v-col :cols="notDesktop ? 6 : 2">
                        <p :class="$style.memberDetailsHeader"> HEIGHT </p>
                        <p
                          v-if="imperialUnits"
                          :class="$style.memberDetailsText"
                          >{{
                            meterConversion(person.dependent_data.height)
                          }}</p
                        >

                        <p
                          v-if="!imperialUnits"
                          :class="$style.memberDetailsText"
                          >{{ person.dependent_data.height || '--' }} M</p
                        >
                      </v-col>

                      <v-col :cols="notDesktop ? 6 : 4">
                        <p :class="$style.memberDetailsHeader"> OCCUPATION </p>
                        <p :class="$style.memberDetailsText">{{
                          person.dependent_data.occupation || '--'
                        }}</p>
                      </v-col>
                      <v-col :cols="notDesktop ? 12 : 4">
                        <p :class="$style.memberDetailsHeader"> EMAIL </p>
                        <p :class="$style.memberDetailsText">{{
                          person.dependent_data.email || '--'
                        }}</p>
                      </v-col>

                      <v-col :cols="notDesktop ? 12 : 4">
                        <p :class="$style.memberDetailsHeader">
                          PHONE NUMBER
                        </p>
                        <p :class="$style.memberDetailsText">{{
                          person.dependent_data.phone_number || '--'
                        }}</p>
                      </v-col>
                    </v-row>
                    <v-row
                      no-gutters
                      class="d-flex flex-column justify-center align-center flex-sm-row justify-sm-start ml-0 ml-sm-6 mb-4 mt-6"
                    >
                      <div
                        class="d-flex align-center mr-0 mr-sm-10 mt-3 mb-5 my-sm-0"
                        @click="editPersonInfo(person)"
                      >
                        <v-img
                          :src="
                            require('@assets/images/safehaven/edit-pen.svg')
                          "
                          height="30"
                          width="20"
                          contain
                          :class="$style.actionIcon"
                        ></v-img>
                        <div class="ml-2">
                          <p :class="$style.personActionText">
                            Edit Information
                          </p>
                        </div>
                      </div>
                      <div
                        class="d-flex align-center"
                        @click="showDeletePopup(index)"
                      >
                        <v-img
                          :src="require('@assets/images/safehaven/bin.svg')"
                          height="30"
                          width="20"
                          contain
                          :class="$style.actionIcon"
                          @click="isShowAlert = true"
                        ></v-img>
                        <div class="ml-2">
                          <p :class="$style.personActionText">
                            Remove Person
                          </p>
                        </div>
                      </div>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </template>

          <router-link :to="{ name: 'caring-person-info' }">
            <v-btn
              :class="[
                'primary-btn',
                $style.noUnderline,
                $vuetify.breakpoint.mobile && 'full-width-btn',
              ]"
              dark
            >
              <v-icon left>mdi-plus-circle</v-icon>Add Person
            </v-btn>
          </router-link>
        </div>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      content-class="body--text"
      height="65"
      color="background"
      :timeout="3000"
    >
      <div class="d-flex">
        <v-icon color="#ee6363" class="my-auto">mdi-close-circle</v-icon>
        <div class="my-auto ml-3">
          {{ snackbarMessage }}
        </div>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn icon color="body" text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.pageContainer {
  padding: 0;
}
a {
  text-decoration: none;
}
.containwrap {
  text-align: left;
}

.pageDesc {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #000;
  letter-spacing: 0.1px;
}

.expansionPanelContainer {
  border: 1px solid #93c0e8;
}

.memberDetailsHeader {
  margin-top: 20px;
  margin-bottom: 10px !important;
  font-size: 11px;
  font-weight: 600;
  line-height: 15px;
  color: #aaa;
  letter-spacing: 1.5px;
}

.memberDetailsText {
  padding-right: 20px;
  margin-top: -5px;
  margin-bottom: 0 !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.15000000596046448px;
  word-wrap: break-word !important;
}

.actionIcon {
  cursor: pointer;
}

.personActionText {
  margin-bottom: 0 !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: #0476d9;
  letter-spacing: 0.10000000149011612px;
  cursor: pointer;
}

.addButton {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  width: 160px;
  height: 40px;
  text-transform: inherit !important;
  background: #0476d9;
  border-radius: 30px;
}

.actionButtonMob {
  align-items: center;
  justify-content: center;
}

.noUnderline {
  text-decoration: none !important;
}

@media screen and (max-width: 960px) {
  .addButton {
    width: 100%;
  }
}
</style>
